// Libraries
import _ from 'lodash';

// Supermove
import {gql} from '@supermove/graphql';
import {withFragment, Json} from '@supermove/utils';

const _getNotificationSettingsJsonValue = (organization: any, key: any) => {
  const notificationSettings = _.get(organization, 'settings.notifications', '{}');
  const json = Json.toCamelCaseKeys(Json.parse(notificationSettings));
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return json[key];
};

const edit = withFragment(
  (organization) => ({
    organizationId: (organization as any).id,
    allowEmployeeText: _getNotificationSettingsJsonValue(organization, 'allowEmployeeText'),
    sendReminderSetSchedule: _getNotificationSettingsJsonValue(
      organization,
      'sendReminderSetSchedule',
    ),
    allowMoverAcceptDeclineJob: _getNotificationSettingsJsonValue(
      organization,
      'allowMoverAcceptDeclineJob',
    ),
  }),
  gql`
    fragment OrganizationMoverNotificationSettingsForm_edit on Organization {
      id
      settings {
        id
        notifications
      }
    }
  `,
);

const toForm = ({
  organizationId,
  allowEmployeeText,
  sendReminderSetSchedule,
  allowMoverAcceptDeclineJob,
}: any) => ({
  organizationId,
  allowEmployeeText,
  sendReminderSetSchedule,
  allowMoverAcceptDeclineJob,
});

const toMutation = ({
  organizationId,
  allowEmployeeText,
  sendReminderSetSchedule,
  allowMoverAcceptDeclineJob,
}: any) => ({
  organizationId,
  allowEmployeeText,
  sendReminderSetSchedule,
  allowMoverAcceptDeclineJob,
});

const OrganizationMoverNotificationSettingsForm = {
  edit,
  toForm,
  toMutation,
};

export default OrganizationMoverNotificationSettingsForm;
